import React, { useEffect, useState } from 'react'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { Box, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import clsx from 'clsx'

import { Dai } from 'components'

import useStyles from './styles'
import theme from 'theme'

const Loading = ({
  text = 'Só um segundo',
  loading = false,
  texts = [],
  lines = 4,
}) => {
  const [dotCount, setDotCount] = useState(1)
  const [textIndex, setTextIndex] = useState(0)
  const classes = useStyles()

  const hasLoadingTexts = texts && texts.length > 0

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev < 3 ? prev + 1 : 1))
    }, 500)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    if (hasLoadingTexts) {
      const interval = setInterval(() => {
        setTextIndex((prev) => {
          if (prev + 1 >= texts.length) {
            clearInterval(interval)
            return prev
          }
          return prev + 1
        })
      }, 5000)
      return () => clearInterval(interval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasLoadingTexts, texts])

  if (!loading) return <></>

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(1)}>
      <Box display="flex" alignItems="center" gridGap={theme.spacing(1)}>
        <Dai.StarIcon size={14} className={classes.daiStarIcon} />
        <SwitchTransition mode="out-in">
          <CSSTransition
            key={hasLoadingTexts ? textIndex : text}
            timeout={500}
            classNames={{
              enter: classes.fadeEnter,
              enterActive: classes.fadeEnterActive,
              exit: classes.fadeExit,
              exitActive: classes.fadeExitActive,
            }}
          >
            <Typography
              variant="body1"
              className={clsx(classes.text, classes.loadingTextTransition)}
            >
              {hasLoadingTexts ? texts[textIndex] : <>{text}</>}
              {'.'.repeat(dotCount)}
            </Typography>
          </CSSTransition>
        </SwitchTransition>
      </Box>
      <Box>
        {Array.from({ length: lines }).map((_, index) => (
          <Skeleton
            key={index}
            width={`${100 - index * 5}%`}
            animation="wave"
            variant="text"
            className={classes.skeletonWave}
          />
        ))}
      </Box>
    </Box>
  )
}

export default Loading
